import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectHasExtinguishingSystem = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('has_extinguishing_system')(jsonQuery),
);
